module.exports = __webpack_public_path__ + "static/media/3_4.a65acc32.png";